import { render } from "./index.vue?vue&type=template&id=58cf51cc"
const script = {}

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__